// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__p4Pjy","para":"styles_para__gDN38","monster":"styles_monster__2doag"};